<template>
  <section class="form-glosa header">
    <header>
      <div>
        <div><label>Mês:</label></div>
          <!-- <b-form-select v-model="form.mes_id" :options="meses"></b-form-select> -->
          <div><select class="form-control" v-model="form.mes_id" >
            <option v-for="mes in meses" :value='mes.id' :disabled="evidenciaEnviada[((mes.id)-1)] === 0 ? false : true" :class="evidenciaEnviada[((mes.id)-1)] === 0 ? '' : 'disabled'" >{{ ((evidenciaEnviada[((mes.id)-1)] === 0) ? (''+ mes.nome + '') : (' - ' + mes.nome + ' * fech. enviado') )   }}</option>
          </select></div>
      </div>

      <div>
          <div><label>Existe glosa:</label></div>
          <div><b-form-select v-model="form.existe_glosa" :options="existeGlosa" v-on:change="restauraFormSelecaoNegativa"></b-form-select></div>
      </div>
    </header>

    <section class="form-glosa body" v-if="form.existe_glosa === 1">
          <b-container fluid>
            <b-row class="b-input-component">
              <b-col sm="3">
                <label>Quantidade:</label>
              </b-col>
              <b-col sm="9">
                <b-form-input type="number" v-model="form.quantidade"></b-form-input>
              </b-col>
            </b-row>
          </b-container>

          <b-container fluid>
            <b-row class="b-input-component">
              <b-col sm="3">
                <label>Valor:</label>
              </b-col>
              <b-col sm="9">
                <money v-model="form.valor" v-bind="money"></money>
              </b-col>
            </b-row>
          </b-container>

          <b-container fluid>
            <b-row class="b-input-component">
              <b-col sm="3">
                <label>Observação:</label>
              </b-col>
              <b-col sm="9">
                  <b-form-textarea
                    v-model="form.observacao"
                    placeholder="Insira uma observação"
                    rows="3"
                    max-rows="6"
                  ></b-form-textarea>
              </b-col>
            </b-row>
          </b-container>

          <b-container fluid>
            <b-row class="b-input-component">
              <b-col sm="3">
                <label>Arquivo:</label>
              </b-col>
              <b-col sm="9">
                  <input type="file" ref="arquivo" value="" v-on:change="getArquivo">
              </b-col>
            </b-row>
          </b-container>

      </section>

      <section>
        <div class="modal-footer">
            <button type="button" class="btn btn-submit" v-on:click="fecharModal()">Cancelar</button>
            <button type="button" class="btn btn-primary btn-submit" v-on:click="salvarGlosa()" v-if="controlerBtnSubmit">Salvar</button>
            <button type="button" class="btn btn-primary btn-submit" disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
        </div>
      </section>

  </section>
</template>

<script>
import {Money} from 'v-money'

export default {
  props: ['contrato'],
  data () {
    return {
      env: process.env,
      form: {
        usuario_nome: this.$store.state.login.loginUsuario.usuario.name,
        usuario_email: this.$store.state.login.loginUsuario.usuario.email,
        mes_id: Number,
        ano: Number,
        quantidade: '',
        valor: '',
        observacao: '',
        arquivo: '',
        contrato_id: Number,
        existe_glosa: 0
      },
      formEstadoInicial: [],
      meses: '',
      existeGlosa: [
        {'text': 'Não', 'value': 0},
        {'text': 'Sim', 'value': 1}
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: ' ',
        precision: 2,
        masked: false
      },
      controlerBtnSubmit: true,
      evidenciaEnviada: []
    }
  },
  components: {
    Money
  },
  mounted: function () {
    this.defineContrato()
    this.getMeses()
    this.copiaFormEstadoInicial()
  },
  watch: {
    contrato: function () {
      this.defineContrato()
    }
  },
  methods: {
    copiaFormEstadoInicial: function () {
      for (let i in this.form) {
        this.formEstadoInicial[i] = this.form[i]
      }
    },
    restauraFormSelecaoNegativa: function () {
      if (this.form.existe_glosa === 0) {
        for (let i in this.formEstadoInicial) {
          if (i !== 'mes_id') {
            this.form[i] = this.formEstadoInicial[i]
          }
        }
      }
    },
    getArquivo: function () {
      let arquivo = this.$refs.arquivo.files[0]
      this.form.arquivo = arquivo
    },
    defineContrato: function () {
      this.evidenciaEnviada = this.$store.state.fechamentoMultaGlosa
      this.form.ano = this.$store.state.ano.ano_selecionado
      this.form.contrato_id = this.contrato.itensContrato.contrato_id
    },
    getMeses: function () {
      let vm = this
      this.$axios.get(`${this.env.FINANCEIRO.GLOSA}/mes`, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`
        }
      }).then(function (response) {
        vm.meses = response.data
        // vm.meses = response.data.map(mes => {
        //   return {'value': mes.id, 'text': mes.nome}
        // })
      })
    },
    confirmarAcao: function () {
      return confirm('Confirma esta ação?')
    },
    salvarGlosa () {
      let vm = this
      let formData = new FormData()
      if (!this.confirmarAcao()) {
        return
      }
      this.form.quantidade = parseInt(this.form.quantidade)
      this.form.valor = parseFloat(this.form.valor)
      for (let atributo in this.form) {
        formData.append(atributo, this.form[atributo])
      }
      this.controlerBtnSubmit = false
      this.$axios.post(`${this.env.FINANCEIRO.GLOSA}/salvarEvidenciaGlosa`, formData, {
        headers: {
          'Authorization': `Bearer ${this.$store.state.login.loginUsuario.token}`,
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        vm.finalizaPosConclusaoSalvarGlosa()
      }).catch(error => {
        vm.controlerBtnSubmit = true
        console.log(error)
      })
    },
    finalizaPosConclusaoSalvarGlosa: function () {
      this.controlerBtnSubmit = true
      let refreshComponentes = Math.floor(Math.random() * 2 * 1000)
      this.$store.commit('setRefreshComponente', refreshComponentes)
      this.fecharModal()
      this.$store.commit('setAlert', {msg: `Glosa salva com sucesso!`, status: true, show: true})
    },
    fecharModal: function () {
      this.$store.commit('setAdicionarGlosa', {conteudo: null, show: false})
    }
  }
}
</script>
<style scoped src="../css/formAdicionarGlosa.css"></style>



// WEBPACK FOOTER //
// FormAdicionarGlosa.vue?2fba4dbe